<template lang="">
    <div class="supply">
 <a-row :gutter="16" style="height: 100%">
                <a-col :span="6" style="height: 100%">
                    <a-row :gutter="16" style="height: 33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer :title="$t('供水监控')" >
                                <SupplyMonitor />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer :title="$t('重点部位压力')">
                                <KeyAreasAndAbnormalPressure />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('实时告警')">
                                <RealTimeDataOfPumpRoom />
                            </DataContainer>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="12" style="height: 100%;display: flex; align-items: center; justify-content: center; padding: 0 20px;">
                    <KeyValue />
                </a-col>
                <a-col :span="6" style="height: 100%">

                    <a-row :gutter="16" style="height: 40%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('水质指标分析')">
                                <WaterQualityIndexLineAnalysis />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 60%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('水质合格率')">
                                <WaterQualityQualificationRate />
                            </DataContainer>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
    </div>
</template>
<script>
import DataContainer from './DataContainer.vue'
import SupplyMonitor from './modules/supply/SupplyMonitor.vue'
import KeyAreasAndAbnormalPressure from './modules/supply/KeyAreasAndAbnormalPressure.vue'
import WaterQualityIndexLineAnalysis from './modules/supply/WaterQualityIndexLineAnalysis.vue'
import WaterQualityQualificationRate from './modules/supply/WaterQualityQualificationRate.vue'
import KeyValue from './modules/supply/KeyValue.vue'
import RealTimeDataOfPumpRoom from './modules/supply/RealTimeDataOfPumpRoom.vue'

export default {
    name: 'Supply',
    components: {
        DataContainer,
        SupplyMonitor,
        KeyAreasAndAbnormalPressure,
        WaterQualityIndexLineAnalysis,
        WaterQualityQualificationRate,
        KeyValue,
        RealTimeDataOfPumpRoom
    },
    props: {
        // 可以添加一些props
    },
    data() {
        return {
        // 可以添加一些数据属性
        }
    },
    methods: {
        // 可以添加一些方法
    },
    mounted() {
        // 可以在这里执行一些初始化操作
    }
    
}
</script>
<style lang="less" scoped>
.supply {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>